<div class="container">

    <div *ngIf="agent$ | async as agent">
        <div class="row">

            <!--Profile-->
            <div class="col-12">
                <mat-card>
                    <div class="row">

                        <div class="col-12">
                            <div><span class="section-header">Profile</span>&nbsp;&nbsp;<a class="edit-button"
                                    (click)="onEditUser()">Edit&nbsp;<fa-icon icon="edit"></fa-icon></a></div>
                            <div class="smallFont">This information is included in your signature to your clients.</div>
                            <div class="Vert-25"></div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xl-1 col-lg-2 col-md-3 col-sm-12 col-xs-12">
                            <div class="float-left" style="margin-right:25px;">
                                <img *ngIf="agentImgUrl$ | async as agentImgUrl" [src]="agentImgUrl"
                                    style="height:125px;" />
                                <div class="Vert-15"></div>
                                <div>
                                    <button style="min-width: max-content;" 
                                    class="btn btn-secondary" (click)="onEditAgentImage()">Edit Photo</button>
                                </div>
                                <div class="Vert-15"></div>

                            </div>

                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                            <div class="float-left">
                                <div class="label">Name</div>
                                <div class="value">{{agent.firstName}} {{agent.lastName}}</div>

                                <div class="label">Email</div>
                                <div class="value">
                                    <a href="mailto:{{agent.email}}">{{agent.email}}</a>
                                </div>

                                <div *ngIf="agent.username" class="label">Username</div>
                                <div class="value" *ngIf="agent.username">
                                    {{agent.username}}
                                </div>

                                <div class="label" *ngIf="agent.username">RFM Email</div>
                                <div class="value" *ngIf="agent.username">
                                    <a
                                        href="mailto:{{agent.username}}@mail.rfm.io">{{agent.username}}&#64;mail.rfm.io</a>
                                </div>

                                <div class="label" *ngIf="agent.address1">Address</div>
                                <div class="value" *ngIf="agent.address1">
                                    {{agent.address1}}, {{agent.city}}, {{agent.state}} {{agent.zipCode}}
                                </div>


                                <ng-container *ngIf="agent.phone || agent.mobilePhone">
                                    <div class="col-12" *ngIf="agent.phone">
                                        <div class="label">Phone (Work)</div>
                                        <div class="value">{{agent.phone}}</div>
                                    </div>
                                    <div class="col-12" *ngIf="agent.mobilePhone">
                                        <div class="label">Phone (Cell)</div>
                                        <div class="value">{{agent.mobilePhone}}</div>
                                    </div>
                                    <div class="col-12" *ngIf="agent.fax">
                                        <div class="label">Fax</div>
                                        <div class="value">{{agent.fax}}</div>
                                    </div>
                                </ng-container>
                            </div>

                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">

                            <div class="label" >Company</div>
                            <div class="value"><span *ngIf="agentCompany$ | async as company">{{company.name}}</span>
                            </div>
                            <div class="label" >Job Title</div>
                            <div class="value">{{agent.jobTitle}}</div>
                            <div class="label" *ngIf="!(lgvUserSvc.isREAgent$| async)">NMLS ID</div>
                            <div *ngIf="!(lgvUserSvc.isREAgent$| async)" class="value">{{agent.nmlsid}}</div>
                            <div class="label" *ngIf="(lgvUserSvc.isREAgent$| async)">License #</div>
                            <div *ngIf="(lgvUserSvc.isREAgent$| async)" class="value">{{agent.licenseNumber}}</div>
                            <div class="label">Website</div>
                            <div><a [href]="qpClientSelfRegistrationLink ?? agent.website"
                                    target="_blank">{{qpClientSelfRegistrationLink ?? agent.website}}</a></div>
                            <div class="Vert-15"></div>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12" *ngIf="agent$ | async as agent2">
                            <div><span class="label">Social Media</span> <a class="edit-button"
                                    (click)="onEditSocialMedia()"> Edit</a></div>
                            <!--<div class="alert alert-warning">
                                Need endpoint to get / set social media for user
                            </div>-->
                            <div *ngFor="let sm of agent2.agentSocialMedia" class="social-media">
                                <div><a class="smallFont" [href]="sm.url" target="_blank"><lgv-social-media-icon
                                            [socialMediaType]="sm.socialMediaTypeId"></lgv-social-media-icon>&nbsp;&nbsp;{{
                                        getSocialMediaTypeName(sm.socialMediaTypeId)
                                        }}</a>
                                </div>
                            </div>
                            <div class="Vert-50"></div>
                            <div class="ck-card" *ngIf="agent?.ckUser?.firstName && agent?.ckUser?.lastName">
                                <p class="ck-title">Concierge Partner</p>
                                <span>{{agent?.ckUser?.firstName + ' ' + agent?.ckUser?.lastName}}</span> <br>
                                <a>{{agent?.ckUser?.email}}</a>
                            </div>
                        </div>
                    </div>
                </mat-card>
            </div>

            <!--QP Self-Registration Link-->
            <div class="col-12">
                <mat-card>
                    <div class="row">
                        <div class="col-lg-9 col-sm-12">
                            <div class="section-header">Your Public Profile</div>
                            <div>Share your link to let your clients start a new loan application!</div>
                            <div class="Vert-20"></div>
                            <div class="row">
                                <div class="col-lg-8 col-sm-12">
                                    <div *ngIf="((mloShortCode$ | async)==null); else mloShortCode"
                                        class="alert alert-info smallFont" style="border: 1px dashed black">
                                        {{qpClientSelfRegistrationLink}}</div>
                                    <ng-template #mloShortCode>
                                        <div class="alert alert-info smallFont" style="border: 1px dashed black">
                                            {{fullMloQpShortUrl}}</div>
                                    </ng-template>
                                </div>
                                <div class="col-lg-4 col-sm-12" style="padding-top:10px;">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <a style="padding-right:40px;" (click)="onClickCopyQP()"
                                                title="Copy link"><fa-icon icon="copy"></fa-icon> Copy Link</a>
                                            <a (click)="onPreviewQP()" title="Preview"><fa-icon
                                                    icon="arrow-circle-right"></fa-icon>
                                                Go to Page</a><br>
                                        </div>
                                        <div class="Vert-15"></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-3 col-sm-12">
                            <qrcode [qrdata]="qpClientSelfRegistrationLink" (qrCodeURL)="onQrCodeUrlChange($event)"
                                [allowEmptyString]="true"
                                [ariaLabel]="'Realfinity Profile Link for {{agent.firstName}} {{agent.lastName}}'"
                                [colorDark]="darkColor" [colorLight]="lightColor" [elementType]="'canvas'"
                                [errorCorrectionLevel]="'M'" [margin]="1" [scale]="4"
                                [title]="'{{agent.firstName}} {{agent.lastName}} Realfinity webpage'">
                            </qrcode>
                            <div>
                                <a class="btn btn-secondary my-2" [href]="qrCodeDownloadLink"
                                    download="Realfinity-QR-Code.png">Download Code</a>
                            </div>
                            <mat-slide-toggle (change)="onToggleDark()">Dark</mat-slide-toggle>
                            <div class="Vert-15"></div>
                        </div>
                    </div>
                </mat-card>
            </div>

            <!--Change Password-->
            <div class="col-lg-6 col-sm-12">
                <mat-card class="syncHeightChgPwdAndBilling">
                    <div class="section-header">Change Password</div>
                    <div class="smallFont">Use the link below to reset your password. Please check your email for next
                        steps.</div>
                    <div class="Vert-25"></div>
                    <div><button class="btn btn-primary" [disabled]="!agent.identityServiceId"
                            (click)="onResetPassword(); $event.stopPropagation();">Send Reset PW Link</button></div>
                </mat-card>
            </div>

            <!-- Hide Billing and Invite Agent for Prod / UAT, and adjust pricing preferences to fill in space where billing was. -->

            <!--Billing-->
            <div class="col-lg-6 col-sm-12">
                <mat-card class="syncHeightChgPwdAndBilling" *ngIf="billingStatus$ | async as billingStatus">
                    <div class="section-header">Billing</div>
                    <div class="smallFont">Click on the billing portal link below to access billing account information,
                        payment methods, and billing history.</div>
                    <div class="Vert-25"></div>
                    <div *ngIf="billingStatus === 'Loading'">
                        <lgv-loading-indicator [CSSClass]="'Small'"></lgv-loading-indicator>
                    </div>
                    <div *ngIf="billingStatus === 'NoAccount'">
                        <a (click)="onCreateBillingAccount()"><fa-icon icon="plus"></fa-icon>&nbsp;Add Payment
                            Method</a>
                    </div>
                    <div *ngIf="billingStatus === 'NoPaymentMethod'">
                        <a (click)="onLaunchBillingModal('manage-payment-sources')"><fa-icon
                                icon="plus"></fa-icon>&nbsp;Add Payment
                            Method</a><!--&nbsp;&nbsp;<a click="onUpdateBillingStatus()"><fa-icon icon="arrow-circle-down"></fa-icon> Refresh</a>-->
                    </div>
                    <div *ngIf="billingStatus === 'Good'">
                        <a (click)="onLaunchBillingModal('portal_sessions')"><fa-icon
                                icon="credit-card"></fa-icon>&nbsp;Access Billing Portal</a>
                    </div>
                </mat-card>
            </div>

            <!--Pricing Preferences-->
            <!--            <div class="col-12">-->
            <!-- <div class="col-lg-12 col-sm-12" *ngIf="agent.isReadyForPricing && !(lgvUserSvc.isREAgent$ | async)">
                <mat-card>
                    <div class="section-header">Pricing Preferences
                        <a class="edit-button" *ngIf="lgvUserSvc.IsAnyAdmin" (click)="
                            onEditBillingPreferences()">Edit&nbsp;<fa-icon icon="edit"></fa-icon></a>
                    </div>
                    <p>Target Price:<br><strong>{{pricingSettings?.targetPrice}}</strong></p>
                    <p>Max Fee:<br><strong>{{pricingSettings?.maxFee}}</strong></p>
                </mat-card>
            </div> -->

            <!--Co-Branding Agents-->
            <div class="col-12">
                <mat-card>
                    <div class="section-header">Co-Branding Agents</div>
                    <div class="Vert-25"></div>

                    <table class='table table-striped' *ngIf="coBrandingAgents$ | async as coBrandingAgents">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Company</th>
                                <th>Organization</th>
                                <th>City</th>
                                <th>State</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let cbAgent of coBrandingAgents">
                                <td>{{cbAgent.agentInfo?.firstName}} {{cbAgent.lastName}}</td>
                                <td>{{cbAgent.agentInfo?.email}}</td>
                                <td>{{cbAgent?.company?.name}}</td>
                                <td>{{cbAgent?.organization?.name}}</td>
                                <td>{{cbAgent.agentInfo?.city}}</td>
                                <td>{{cbAgent.agentInfo?.state}}</td>
                            </tr>
                        </tbody>
                    </table>



                </mat-card>
            </div>

            <!--Licenses-->
            <div class="col-12">
                <mat-card>
                    <span style="display: flex; flex-direction: row; justify-content: space-between;">
                        <div class="section-header">Licenses</div>
                        <button class="btn btn-primary" (click)="onEditLicense()">Add License</button>
                    </span>


                    <div class="Vert-10"></div>

                    <table class='table table-striped' *ngIf="userLicenses$ | async as licenses">
                        <thead>
                            <tr>
                                <th>License Number</th>
                                <th>State</th>
                                <th>Status</th>
                                <th>Valid Until</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let license of licenses">
                                <td>
                                    <a class="action-link" (click)="onEditLicense(license)" title="Edit">
                                    {{license.stateLicenseNumber}}</a>
                                </td>
                                <td>{{getStateAbbreviation(license.state)}}</td>
                                <td>
                                    <span>
                                        {{license.status}}
                                    </span>
                                </td>
                                <td>{{license.expirationYear | date:'yyyy'}}</td>
                                <td>
                                    <a class="action-link" (click)="onEditLicense(license)" title="Edit">
                                        <fa-icon icon="edit"></fa-icon>
                                    </a>
                                    &nbsp;
                                    <a class="action-link" (click)="onDeleteLicense(license)" title="Delete">
                                        <fa-icon icon="trash"></fa-icon>
                                    </a>
                                </td>
                            </tr>
                            <tr *ngIf="licenses.length === 0">
                                <td colspan="5" class="text-center">No licenses found</td>
                            </tr>
                        </tbody>
                    </table>
                </mat-card>
            </div>

            <!--Assisted binding-->
            <div class="Vert-25"></div>
            <div class="col-12" *ngIf="(lgvUserSvc.IsAdmin)">
                <mat-card>
                    <div class="section-header">Assistants</div>
                    <mat-card-subtitle>
                        <div class="row">
                            <div class="col-lg-4 col-sm-12">
                                <ul class="list-group mb-3">
                                    <li class="d-flex justify-content-between pr-5">
                                        <div>
                                            <b class="my-0">Assisted By</b>
                                        </div>
                                        <div>
                                            <b class="my-0">Getting Email</b>
                                        </div>
                                    </li>
                                    <ng-container *ngIf="assistants$ | async as assistantsList">
                                        <li *ngFor="let x of assistantsList"
                                            class="d-flex justify-content-between lh-sm">
                                            <div>
                                                <span>{{x.firstName}} {{x.lastName}} </span>
                                                <a *ngIf="lgvUserSvc.IsAnyAdmin" class="subtleLink"
                                                    (click)="onRemoveAssistant(x.id)"><fa-icon icon="times-circle"
                                                        title="Remove Assistant"></fa-icon></a>
                                            </div>
                                            <div>
                                                <span><fa-icon icon="check"
                                                        *ngIf="x.alertWhenEmailSent"></fa-icon></span>
                                            </div>
                                        </li>
                                    </ng-container>
                                </ul>

                            </div>

                            <div class="col-lg-4 col-sm-12">
                                <ul class="list-group mb-3">
                                    <li class="d-flex justify-content-between pr-5">
                                        <div>
                                            <b class="my-0">Assisting</b>
                                        </div>
                                        <div>
                                            <b class="my-0">Getting Email</b>
                                        </div>
                                    </li>
                                    <ng-container *ngIf="assistingAgents$ | async as assistingList">
                                        <li *ngFor="let x of assistingList"
                                            class="d-flex justify-content-between lh-sm">
                                            <div>
                                                <span>{{x.firstName}} {{x.lastName}} </span>
                                                <a *ngIf="lgvUserSvc.IsAnyAdmin" class="subtleLink"
                                                    (click)="onRemoveAssistingAgent(x.id)"><fa-icon icon="times-circle"
                                                        title="Remove Assistant"></fa-icon></a>
                                            </div>
                                            <div>
                                                <span><fa-icon icon="check"
                                                        *ngIf="x.alertWhenEmailSent"></fa-icon></span>
                                            </div>
                                        </li>
                                    </ng-container>
                                </ul>
                            </div>
                            <div class="col-lg-4 col-sm-12" *ngIf="lgvUserSvc.IsAnyAdmin">

                                <div>
                                    <div class="label">Add Assistant Binding to <span>{{agentInfo.firstName}}
                                                {{agentInfo.lastName}}</span>
                                    </div>
                                    <div>
                                        <mat-radio-group aria-label="What kind of binding?">
                                            <mat-radio-button value="Assistant"
                                                (change)="onNewBindingIsAgentChanged($event)"
                                                [checked]="newAssistantBindingType === 'Assistant'">Assisted
                                                by</mat-radio-button>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <mat-radio-button value="Agent"
                                                (change)="onNewBindingIsAgentChanged($event)"
                                                [checked]="newAssistantBindingType !== 'Assistant'">Assisting</mat-radio-button>
                                        </mat-radio-group>
                                    </div>
                                    <div>
                                        <mat-placeholder style="text-size-adjust:100%"><b>Include Assistant on Agent Emails</b></mat-placeholder>
                                        <mat-slide-toggle [checked]="assistantGetsEmails"
                                            (change)="onToggleNewAssistantGetsEmails($event, x)"
                                            style="margin-left:15px">
                                        </mat-slide-toggle>
                                    </div>
                                </div>

                                <div class="Vert-15"></div>

                                <lgv-user-search [SearchState]="childSearchState"
                                    (OnUserSelectionMade)="onUserSelectionMade($event)"></lgv-user-search>

                                <div class="Vert-10"></div>
                                <button class="btn btn-primary" [disabled]="!selectedAssistantBindingUser || (isLoading$ | async)"
                                    (click)="onAddAssistantBinding()">Add
                                    <span *ngIf="selectedAssistantBindingUser">
                                        {{selectedAssistantBindingUser.firstName}}
                                        {{selectedAssistantBindingUser.lastName}}</span> as
                                    {{newAssistantBindingType}}</button>

                            </div>
                        </div>
                    </mat-card-subtitle>
                </mat-card>
            </div>

            <!--Assisted binding-->
            <div class="Vert-25"></div>
            <div class="col-12" *ngIf="(lgvUserSvc.IsAdmin)">
                <mat-card style="background-color:#ddd;">
                    <div class="section-header">Concierge Key</div>
                    <div class="row">
                        <div class="col-6">
                            <div class="label"><b>Assigned CK</b></div>
                            <ng-container *ngIf="assignedCkUser$ | async as assigned; else noCkAssigned">
                                <div>
                                    {{ assigned.firstName }} {{ assigned.lastName }}
                                </div>
                            </ng-container>
                            <ng-template #noCkAssigned>
                                <div class="value text-muted">No CK assigned</div>
                            </ng-template>
                        </div>
                        <div class="col-6">
                            <lgv-user-search [SearchState]="ckSearchState"
                                (OnUserSelectionMade)="onCKSelection($event)">
                            </lgv-user-search>

                            <div class="Vert-10"></div>
                            <!-- One button with dynamic label + disabled state -->
                            <button class="btn btn-primary" (click)="onChangeCKUser()"
                                [disabled]="!(assignedCkUser$ | async) && !(selectedCkUser$ | async)">

                                <!-- 1) assigned == null AND selected == null => "Disabled" -->
                                <ng-container *ngIf="!(assignedCkUser$ | async) && !(selectedCkUser$ | async)">
                                    Disabled
                                </ng-container>

                                <!-- 2) assigned != null AND selected == null => "Remove CK" -->
                                <ng-container *ngIf="(assignedCkUser$ | async) && !(selectedCkUser$ | async)">
                                    Remove CK
                                </ng-container>

                                <ng-container *ngIf="!(assignedCkUser$ | async) && (selectedCkUser$ | async)">
                                    Add CK
                                </ng-container>

                                <ng-container *ngIf="(assignedCkUser$ | async) && (selectedCkUser$ | async)">
                                    Change CK
                                </ng-container>
                            </button>
                        </div>
                    </div>
                </mat-card>
            </div>

            <!--Admin Section-->
            <div class="col-12" *ngIf="lgvUserSvc.IsAnyAdmin">
                <mat-card style="background-color:#ddd;">
                    <div class="section-header">Admin Info</div>
                    <div class="smallFont">This seciton is only visible to admins.</div>
                    <div class="Vert-20"></div>
                    <div class="row">
                        <div class="col-4">
                            <div class="label">User ID</div>
                            <div class="value">{{agent.id}}</div>
                        </div>
                        <div class="col-4">
                            <div class="label">IdentityServiceID</div>
                            <div class="value">{{agent.identityServiceId}}</div>
                        </div>

                        <div class="col-4">
                            <div class="label">Hide Pricing</div>
                            <mat-slide-toggle [checked]="agent.hidePricingForClientView"
                                (change)="onTogglePricing($event, x)">
                            </mat-slide-toggle>
                        </div>
                        <div class=" col-4">
                            <div class="label">Enrollment Date</div>
                            <div class="value">{{agent.enrollmentDate | date:'short'}}</div>
                        </div>
                        <div class="col-4">
                            <mat-placeholder class="label">Go Live w/ Email Campaign</mat-placeholder>
                            <mat-slide-toggle [checked]="agentIsLive" (change)="onToggleGoLive($event, x)"
                                style="margin-left:15px">
                            </mat-slide-toggle>
                        </div>
                        <div class="col-4" *ngIf="!(lgvUserSvc.isREAgent$ | async)">
                            Last Invitation Sent: {{agent.loinvitationSentDate | LgvUTCDate |
                            date:'short'}}
                            <div *ngIf="!(canSendNewInvitation$ | async)" class="warning small">
                                (Must wait 24 hours before sending another invite)
                            </div>
                            <div>
                                <button class="btn btn-secondary" (click)="onConfirmSendInvitationEmail()"
                                    [disabled]="(!(canSendNewInvitation$ | async)) || (invitationJustSent$ | async)">Send
                                    Invitation Email</button>
                            </div>
                        </div>
                        <div class=" col-4">
                            <div class="label">Application Url</div>
                            <div class="value">{{agent.applicationUrl}}</div>
                        </div>
                        <!-- Only used by NFM -->
                        <!-- 
                        <div class="col-4">
                            <mat-placeholder></mat-placeholder>
                            <button class="btn btn-secondary" [disabled]="!agent.identityServiceId"
                                (click)="onResetPassword(); $event.stopPropagation();">Reset Password</button>
                        </div> -->
                    </div>
                    <div class="Vert-20"></div>
                    <div class="row">
                        <div class="col-4">
                            <div class="label">OB Channel Index</div>
                            <div class="value">{{agent.obchannelIndex}}</div>
                        </div>
                        <div class="col-4">
                            <div class="label">OB Originator Index</div>
                            <div class="value">{{agent.oboriginatorIndex}}</div>
                        </div>
                    </div>
                    <div class="Vert-20"></div>
                    <div class="row" *ngIf="!(lgvUserSvc.isREAgent$ | async)">
                        <div class="col-lg-6 col-sm-12">
                            <div class="label">Invitation url</div>
                            <div class="alert alert-info smallFont" style="border: 1px dashed black">
                                {{invitationUrl}}</div>
                        </div>
                    </div>
                    <div class="Vert-20"></div>
                    <div>
                        <button class="btn btn-warning" (click)="onConfirmDeleteUser(agent.id)" *ngIf="!!agent.isDisabled">Enable User</button>
                        <button class="btn btn-danger" (click)="onConfirmDeleteUser(agent.id)" *ngIf="!agent.isDisabled">Disable User</button>
                    </div>
                </mat-card>
            </div>

        </div>

    </div>
</div>